module.exports = __webpack_public_path__ + "static/media/scc_logo.d8aab7f6.jpeg";